import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.CancellationException
import kotlinx.serialization.Serializable
import models.DomainGame

private var cachedCreatorUids: Set<String> = emptySet()

@Serializable
internal data class CreatorUuidsConfig(
    val uids: List<String> = emptyList(),
)

internal fun isCreatorUid(uid: String, creatorUids: Set<String> = cachedCreatorUids): Boolean =
    uid in creatorUids

internal fun hasCreatorPlayer(
    game: DomainGame,
    creatorUids: Set<String> = cachedCreatorUids,
): Boolean =
    game.players.any { isCreatorUid(it.ownerUid, creatorUids) }

internal fun unlockCreatorDiceForUid(uid: String, creatorUids: Set<String> = cachedCreatorUids): Boolean =
    if (isCreatorUid(uid, creatorUids)) Achievements.unlockCreatorDice() else false

internal suspend fun unlockCreatorDiceForCurrentFirebaseUser(): Boolean {
    return try {
        val uid = FirebaseAuthSession.requireUid()
        val creatorUids = refreshCreatorUids()
        unlockCreatorDiceForUid(uid, creatorUids)
    } catch (e: CancellationException) {
        throw e
    } catch (_: Throwable) {
        false
    }
}

internal suspend fun refreshCreatorUids(): Set<String> {
    FirebaseAuthSession.requireUid()
    val snapshot = Firebase.firestore
        .collection(APP_CONFIG_COLLECTION)
        .document(CREATOR_UUIDS_DOCUMENT)
        .get()
    cachedCreatorUids = if (snapshot.exists) {
        snapshot.data(CreatorUuidsConfig.serializer()).uids
            .map { it.trim() }
            .filter { it.isNotEmpty() }
            .toSet()
    } else {
        emptySet()
    }
    return cachedCreatorUids
}

private const val APP_CONFIG_COLLECTION = "appConfig"
private const val CREATOR_UUIDS_DOCUMENT = "creatorUuids"
